import React from 'react';

const Resume = ({ data }) => {
  if (!data) return null;

  const { skillmessage, education, work, skills } = data;

  const companyTags = (companyName) => {
    const comp = companyName.toUpperCase();
    if (comp.includes('AMERICAN EXPRESS') && comp.includes('SUNRISE')) {
      return ['Agentic AI', 'AWN / LangGraph', 'ACE MOD Registry', 'HITL Governance', 'Knowledge Discovery', 'Delivery Excellence'];
    }
    if (comp.includes('NORDSTROM')) {
      return ['Merchandise Financial Planning', 'Assortment Planning', 'Enterprise Master Data', 'Product Strategy', 'Retail Tech'];
    }
    if (comp.includes('AMAZON')) {
      return ['Amazon Payments', 'Prime Card Portfolio', 'AWS Ecosystem', 'Java / Distributed Systems', 'Operational Excellence'];
    }
    if (comp.includes('ATOS') || comp.includes('TATA') || comp.includes('AMERICAN EXPRESS')) {
      return ['Global Merchant Payments', 'SWIFT Integration', 'LATAM Expansion', 'Team Leadership (15+)', 'Fintech & Settlement'];
    }
    if (comp.includes('OWARI') || comp.includes('TOYOTA')) {
      return ['Toyota Production System (TPS)', 'Quality Assurance', 'Precision Engineering'];
    }
    return [];
  };

  const educationList = education.map((edu) => (
    <div key={edu.school} className="resume-item">
      <h3>{edu.school}</h3>
      <div className="resume-meta">
        <img
          src={`/images/${edu.image}.png`}
          alt={edu.school}
          style={{ width: '100px', marginRight: '20px' }}
        />
        <div className="resume-info">
          <p className="info">
            {edu.degree} <span>&bull;</span>{' '}
            <em className="date">{edu.graduated}</em>
          </p>
        </div>
      </div>
      <p>{edu.description}</p>
    </div>
  ));

  const workList = work.map((job) => (
    <div key={job.company} className="resume-item">
      <h3>{job.company}</h3>
      <div className="resume-meta">
        <img
          src={`/images/${job.image}.png`}
          alt={job.company}
          style={{ width: '100px', marginRight: '10px' }}
        />
        {job.image2 && job.image2 !== 'blank' && (
          <img
            src={`/images/${job.image2}.png`}
            alt={job.company}
            className="resume-logo"
          />
        )}
      </div>
      <p className="info">
        {job.title}
        <span>&bull;</span> <em className="date">{job.years}</em>
      </p>
      <p>{job.description}</p>
    </div>
  ));

  const skillsList = skills.map((skill) => {
    return (
      <li key={skill.name}>
        <span
          style={{ width: skill.level }}
          className={`bar-expand ${skill.name.toLowerCase().replace(/\s/g, '-')}`}
        ></span>
        <em>{skill.name}</em>
      </li>
    );
  });

  return (
    <section id="resume">
      <div className="row education">
        <div className="three columns header-col">
          <h1>
            <span>Education</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="timeline-wrap">
            {education.map((degree) => (
              <div key={degree.school} className="timeline-block">
                <div className="timeline-ico">
                  <i className="fa fa-graduation-cap"></i>
                </div>
                <div className="timeline-header">
                  <h3>{degree.school}</h3>
                  <p className="timeline-date">
                    {degree.graduated}
                  </p>
                </div>
                <div className="timeline-content">
                  <h4>{degree.degree}</h4>
                  <p>{degree.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="row work">
        <div className="three columns header-col">
          <h1>
            <span>Work</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <div className="timeline-wrap">
            {work.map((job) => {
              const tags = companyTags(job.company);
              return (
                <div key={job.company} className="timeline-block glass-timeline-card">
                  <div className="timeline-ico">
                    <i className="fa fa-briefcase"></i>
                  </div>
                  <div className="timeline-header">
                    <h3>{job.company}</h3>
                    <p className="timeline-date">
                      {job.years}
                    </p>
                  </div>
                  <div className="timeline-content">
                    <h4>{job.title}</h4>
                    <div className="resume-logos">
                      <img
                        src={`/images/${job.image}.png`}
                        alt={job.company}
                        className="resume-logo"
                      />
                      {job.image2 !== 'blank' && (
                        <img
                          src={`/images/${job.image2}.png`}
                          alt={job.company}
                          className="resume-logo"
                        />
                      )}
                    </div>
                    <p>{job.description}</p>
                    {tags.length > 0 && (
                      <div className="job-tags">
                        {tags.map((tag) => (
                          <span key={tag} className="job-tag-chip">{tag}</span>
                        ))}
                      </div>
                    )}
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>

      <div className="row skill">
        <div className="three columns header-col">
          <h1>
            <span>Skills</span>
          </h1>
        </div>

        <div className="nine columns main-col">
          <p>{skillmessage}</p>

          <div className="skills-grid">
            {skills.map((skill) => {
              const isAI = skill.name.includes("AI") || skill.name.includes("Generative");
              return (
                <div key={skill.name} className={`skill-item ${isAI ? 'ai-highlight' : ''}`}>
                  <div className="skill-info">
                    <span className="skill-name">{skill.name}</span>
                  </div>
                  <div className="skill-bar">
                    <div
                      className={`skill-progress ${isAI ? 'ai-bar' : ''}`}
                      style={{ width: skill.level }}
                    ></div>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Resume;
